/* SAEGE - Klarna message below the Add to Bag button.
 *
 * This is now the ONLY Klarna placement on the PDP. The original line under
 * the price is hidden - but by CSS, and only once this script has actually
 * inserted the panel: it adds .saege-klarna-cloned to <html>, and the hide
 * rule in the stylesheet hangs off that class. If anything here fails, the
 * class is never added and the original line stays exactly where it was. The
 * page can lose the new placement; it can never end up with no Klarna message
 * at all.
 *
 * Why a clone and not a move: the block is server-rendered Liquid from a
 * custom_liquid block in the product template and does not survive being
 * relocated. The source stays put in the DOM (display:none) purely so there
 * is something to clone from.
 *
 * Insertion point: immediately BEFORE the trust lines, so the order reads
 * button -> Klarna -> USPs. The trust block is itself injected by
 * assets/saege-pdp.js on a retry loop, so this waits for it rather than
 * assuming it is already there - inserting first would leave the USPs above
 * the panel.
 *
 * THE INFO DOT. It used to be stripped, back when this was a side-by-side
 * test and the original under the price still carried one. Now that the
 * original is hidden, this panel is the only route to Klarna's terms, so the
 * dot has to come with it - and it has to work. It is a <button> the theme
 * wires up directly, so a cloned copy inherits no handler and would be a dead
 * control sitting over the credit terms. Rather than hope the theme's handler
 * is delegated, the clone gets its own toggle driven by
 * .saege-klarna-panel--open, and swallows the click so the two cannot fight.
 * For the same reason the clone is no longer aria-hidden - it is not a
 * duplicate any more, it is the message.
 *
 * Copy fix: the source sentence ends "...at 0% interest with" and relies on
 * the "Klarna." wordmark that follows it to finish the line. In the panel that
 * wordmark becomes a badge on the LEFT, which leaves the sentence dangling on
 * the word "with". So the trailing "with" is trimmed from the clone.
 *
 * Styles: assets/saege-klarna-below-button.css
 * Turn off: klarna_below_button in snippets/saege-pdp-loader.liquid - which
 * also restores the line under the price, since the hide rule lives in this
 * file's stylesheet.
 */
(function () {
  'use strict';

  var tries = 0;

  /* trim a trailing "with" from the last text node that has one */
  function dropTrailingWith(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var last = null;
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.trim()) last = n;
    }
    if (last) {
      last.nodeValue = last.nodeValue.replace(/\s*\bwith\b[\s.]*$/i, '');
    }
  }

  function wireInfo(panel, copy) {
    var info = copy.querySelector('.saege-klarna__info');
    if (!info) return;
    info.setAttribute('type', 'button');
    info.setAttribute('aria-expanded', 'false');
    info.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var open = panel.classList.toggle('saege-klarna-panel--open');
      info.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function build() {
    if (document.querySelector('.saege-klarna-panel')) return true;

    var source = document.querySelector('.saege-o-klarna .saege-klarna') ||
                 document.querySelector('.saege-klarna');
    var buy = document.querySelector('.buy-buttons-row');
    if (!source || !buy || !buy.parentNode) return false;

    /* wait for the trust block so the panel can go above it, but do not wait
       forever - after ~4s take the slot right after the button instead */
    var trust = document.querySelector('.saege-trust');
    if (!trust && tries < 16) return false;

    var panel = document.createElement('div');
    panel.className = 'saege-klarna-panel';

    var copy = source.cloneNode(true);

    var sentence = copy.querySelector('.saege-klarna__text') || copy;
    dropTrailingWith(sentence);

    wireInfo(panel, copy);
    panel.appendChild(copy);

    if (trust && trust.parentNode === buy.parentNode) {
      buy.parentNode.insertBefore(panel, trust);
    } else {
      buy.parentNode.insertBefore(panel, buy.nextSibling);
    }

    /* only now is it safe to hide the original */
    document.documentElement.classList.add('saege-klarna-cloned');
    return true;
  }

  function start() {
    if (build()) return;
    var iv = setInterval(function () {
      tries++;
      if (build() || tries > 40) clearInterval(iv);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
